import React, { memo } from 'react';
import { useTrustyState } from '../TrustyProvider';
import css from './TrustyGameItem.module.css';

export const TrustyGameItem = memo(() => {
    const state = useTrustyState();
    const { currentPair } = state.context;

    if (!currentPair) return null;

    const { question, answer } = currentPair;

    return (
        <div className={css.container}>
            <div className={css.pairWrapper}>
                <div className={css.questionBox}>
                    <div className={css.text}>{question}</div>
                </div>
                
                <div className={css.divider}></div>

                <div className={css.answerBox}>
                    <div className={css.text}>{answer}</div>
                </div>
            </div>
        </div>
    );
});
